import '@/configs/env'; // Validate environment variables on startup
import '@/locales/i18n';
import './index.css';

import { StrictMode } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createRoot } from 'react-dom/client';
import { Toaster } from 'sonner';

import { ApiError } from '@/apis/client';
import Routes from '@/routes';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider
      client={
        new QueryClient({
          defaultOptions: {
            queries: {
              staleTime: 1000 * 60 * 5, // 5 minutes
              gcTime: 1000 * 60 * 10, // 10 minutes (formerly cacheTime)
              retry: (failureCount, error) => {
                // Don't retry on 4xx client errors
                if (ApiError.isClientError(error)) {
                  return false;
                }
                // Retry up to 3 times for other errors
                return failureCount < 3;
              },
              refetchOnWindowFocus: true,
            },
            mutations: {
              retry: (failureCount, error) => {
                // Don't retry mutations on client errors
                if (ApiError.isClientError(error)) {
                  return false;
                }
                return failureCount < 1; // Only retry once for mutations
              },
            },
          },
        })
      }
    >
      <Routes />
      <Toaster position="bottom-right" expand={false} richColors theme="dark" />
    </QueryClientProvider>
  </StrictMode>
);
